import { render, staticRenderFns } from "./edit-reporters.component.html?vue&type=template&id=47164920&scoped=true&"
import script from "./edit-reporters.component.ts?vue&type=script&lang=ts&"
export * from "./edit-reporters.component.ts?vue&type=script&lang=ts&"
import style0 from "./edit-reporters.component.scss?vue&type=style&index=0&id=47164920&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47164920",
  null
  
)

export default component.exports